export default __webpack_public_path__ + "static/media/call-to-action3.b7eaf473.jpg";